import { ReactNode, ButtonHTMLAttributes } from 'react'

export function PageTitle({ children }: { children: ReactNode }) {
  return (
    <h1 className="font-display text-5xl font-medium text-cream tracking-tight leading-[1.05]" style={{ fontVariationSettings: '"opsz" 144, "SOFT" 50' }}>
      {children}
    </h1>
  )
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <h2 className="flex items-center gap-3 text-sm font-medium text-mute mb-6">
      <span className="w-1.5 h-1.5 bg-ember" />
      {children}
    </h2>
  )
}

export function Badge({
  children,
  variant = 'default',
}: {
  children: ReactNode
  variant?: 'default' | 'success' | 'warning' | 'danger'
}) {
  const variants = {
    default: 'bg-ink-raised text-cream border-haze/60',
    success: 'bg-leaf/15 text-leaf border-leaf/30',
    warning: 'bg-ember/15 text-ember border-ember/30',
    danger: 'bg-ember text-ink border-transparent',
  }
  return (
    <span className={`inline-flex items-center px-3 py-1 text-xs font-medium border ${variants[variant]}`}>
      {children}
    </span>
  )
}

export function IconButton({
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center w-11 h-11 bg-transparent text-mute hover:text-cream hover:bg-ink-raised border border-haze hover:border-ember transition-all duration-300 ${props.className || ''}`}
    >
      {children}
    </button>
  )
}
